import { Header, Configuration as ConfigurationComponent } from "components"
export const Configuration = () => {
 return (
  <div>
   <Header />
   <ConfigurationComponent />
  </div>
 )
}
